import { render, staticRenderFns } from "./AdditionalSettingsStatistics.vue?vue&type=template&id=16cb7529&"
import script from "./AdditionalSettingsStatistics.vue?vue&type=script&lang=js&"
export * from "./AdditionalSettingsStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports